import {
  getStatusColor,
  getStatusLabel,
} from 'src/pages/CallAnalyticsPage/utils'

const CallConversionBadge = ({
  status,
  connectedStatus,
  voeFindings,
}: {
  status: string
  connectedStatus: string
  voeFindings?: readonly string[] | null
}) => {
  if (!status) {
    return null
  }

  return (
    <div
      className={`shrink-0 text-nowrap rounded px-2 py-1 text-xs
        ${getStatusColor(status, connectedStatus)}`}
    >
      {getStatusLabel(status, connectedStatus, voeFindings)}
    </div>
  )
}

export default CallConversionBadge
